import { ProjectsDto  } from "@gtpl/shared-models/gtpl";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllProjectsResponseModel extends GlobalResponseObject {
    data?: ProjectsDto[];
}

